import React from 'react';
import { useForm } from 'react-hook-form';
import Card from 'src/components/common/Card.redesign';
import BillingAndPaymentCycle from 'src/models/BillingAndPaymentCycle';
import Landman from 'src/models/Landman';
import ProjectAdministratorStaff from 'src/models/ProjectAdministratorStaff';
import ProjectStaff from 'src/models/ProjectStaff';
import User from 'src/models/User';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import ProjectWorkClassification from 'src/models/ProjectWorkClassification';
// import actions from 'src/actions';
// import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';

interface IStaffingLandmanCard {
    projectStaffInfo: ProjectStaff;
    landman: Landman;
    index: number;
    pcapmList: User[];
    projectAdminStaff: ProjectAdministratorStaff[];
    submitListener: boolean;
    billingCycles: BillingAndPaymentCycle[];
    workClassifications: ProjectWorkClassification[];
    submitStaffingForm: (data: ProjectStaff) => void;
    showDialog: ContextMenuAction[];
    hideDialog: () => void;
    newStaffingInfo?: ProjectStaff;
    deStaffedListener?: (data: boolean) => void;
    updateCardListener?: (data: boolean) => void;
}

const currentYear = new Date().getFullYear();

const StaffedLandmanCard = (props: IStaffingLandmanCard) => {
    const { register } = useForm();
    const dialogContext = React.useContext<dialogCreators>(DialogContext);

    const editLandmen: ContextMenuAction[] = [
        {
            text: 'Edit Staff Info',
            action: () =>
                dialogContext.project.addEditLandmanInfo(
                    props.projectStaffInfo,
                    props.billingCycles,
                    props.pcapmList,
                    props.projectAdminStaff,
                    props.workClassifications,
                    props.updateCardListener
                ),
        },
        {
            text: 'De-Staff Personnel',
            action: () =>
                dialogContext.project.addRemoveLandman(props.projectStaffInfo, props.landman, props.workClassifications, props.deStaffedListener),
        },
    ];

    const startCycle = () => {
        return props?.billingCycles
            .filter((c: BillingAndPaymentCycle) => c.id === props?.projectStaffInfo?.startBillingCycle?.id)
            .map((x: BillingAndPaymentCycle) => {
                if (x.cycleNumber <= 9) {
                    return `${currentYear} - 0${x.cycleNumber}`;
                }
                return `${currentYear} - ${x.cycleNumber}`;
            });
    };

    const endCycle = () => {
        return props?.billingCycles
            .filter((c: BillingAndPaymentCycle) => c.id === props?.projectStaffInfo?.endBillingCycle?.id)
            .map((x: BillingAndPaymentCycle) => {
                if (x.cycleNumber <= 9) {
                    return `${currentYear} - 0${x.cycleNumber}`;
                }
                return `${currentYear} - ${x.cycleNumber}`;
            });
    };

    const pcamp = () => {
        return props.pcapmList
            .filter((item) => item.id === props?.projectStaffInfo?.pcapmId)
            .map((item) => {
                return `${item.firstName} ${item.lastName}`;
            });
    };

    const pm = () => {
        return props.pcapmList
            .filter((item) => item.id === props?.projectStaffInfo?.projectManagerId)
            .map((item) => {
                return `${item.firstName} ${item.lastName}`;
            });
    };

    const workClassification = () => {
        return props.workClassifications
            .filter((item) => item.id === props?.projectStaffInfo?.workClassificationId)
            .map((item) => {
                return `${item.alias} - ${item.name}`;
            });
    };

    return (
        <>
            <Card
                badge={props.projectStaffInfo?.pendingCycle ? 'Pending new cycle' : ''}
                contextActions={editLandmen}
                newContext={true}
                showMenu={true}
            >
                <div className="mb-1 mt-1" key={`Staff${props.index}`}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 3rem 0 3rem', gap: '3%' }}>
                        <div style={{ width: '130px' }}>
                            <p>{`${props.landman.firstName} ${props.landman.lastName}`}</p>
                        </div>
                        <div style={{ width: '100px' }}>
                            <p>{startCycle()}</p>
                        </div>
                        <div style={{ width: '120px' }}>
                            <p>{endCycle()}</p>
                        </div>
                        <div style={{ width: '80px' }}>
                            <p>{props?.projectStaffInfo?.overridePayRate}</p>
                        </div>
                        <div style={{ width: '100px' }}>
                            <p>{props?.projectStaffInfo?.overrideBillRate}</p>
                        </div>
                        <div style={{ width: '100px' }}>
                            <p>{pcamp()}</p>
                        </div>
                        <div style={{ width: '140px' }}>
                            <p>{workClassification()}</p>
                        </div>
                        <div style={{ width: '100px' }}>
                            <p>{pm()}</p>
                        </div>
                        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', width: '300px' }}>
                            <input
                                type="checkbox"
                                name="ownershipAccess"
                                ref={register}
                                defaultChecked={props?.projectStaffInfo?.ownershipAccess}
                                disabled={true}
                            />
                            <label htmlFor="permission1">Ownership Access?</label>
                            <input
                                type="checkbox"
                                name="contractAccess"
                                ref={register}
                                defaultChecked={props?.projectStaffInfo?.contractAccess}
                                disabled={true}
                            />
                            <label htmlFor="permission2">Contract Access?</label>
                            <input
                                type="checkbox"
                                name="reportAccess"
                                ref={register}
                                defaultChecked={props?.projectStaffInfo?.reportAccess}
                                disabled={true}
                            />
                            <label htmlFor="permission3">Report Access?</label>
                        </div>
                    </div>
                </div>
            </Card>
        </>
    );
};

export default StaffedLandmanCard;



// WEBPACK FOOTER //
// ./src/components/project/sections/StaffedLandmanCard.tsx